<template> 
  <div id="app">
    <!-- <tabbar/> -->
    <router-view></router-view> 
  </div>
</template>
<style>
  body {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }

  #app {
    height: 99.9vh;
    /* border: 1px solid blue; */
    overflow: auto;
    background-color: #ffffff;
  }

  img {
    width: 100%;
    height: 100%;
  }
  input {
    border: none;
    outline: none;
    padding: 0.2vw 0.6vw;
  }
  textarea{
    /* border: none; */
    outline: none;
    padding: 0.2vw 0.6vw;
  }
  ::-webkit-scrollbar {
    width: 8px;
    /* 对于垂直滚动条，设置宽度 */
  }

  ::-webkit-scrollbar-thumb {
    background: #011528;
    /* 滑块颜色 */
    border-radius: 50px;
  }

  /* 滚动条轨道 */
  ::-webkit-scrollbar-track {
    background: #d9d9da;
    /* 轨道颜色 */
  }

  /* 滑块hover效果 */
  ::-webkit-scrollbar-thumb:hover {
    background: #011528;
    /* 滑块hover颜色 */
  }
</style>

<script>
//  import tabbar from '@/components/navbar/navbar.vue'; // 确保路径正确

export default {
  name: 'App',
  components: {
    // tabbar, 
   }
};
</script>